import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  style = {},
  fill = "var(--tlx-surface-bg-surface)",
  width = 48,
  height = 48,
  className = "",
  viewBox,
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox || "0 0 48 48"}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M0.5 8.625C0.5 6.47012 1.35602 4.40349 2.87976 2.87976C4.40349 1.35602 6.47012 0.5 8.625 0.5H37.375C39.5299 0.5 41.5965 1.35602 43.1202 2.87976C44.644 4.40349 45.5 6.47012 45.5 8.625V37.375C45.5 39.5299 44.644 41.5965 43.1202 43.1202C41.5965 44.644 39.5299 45.5 37.375 45.5H8.625C6.47012 45.5 4.40349 44.644 2.87976 43.1202C1.35602 41.5965 0.5 39.5299 0.5 37.375V8.625ZM8.625 4.25C7.46468 4.25 6.35188 4.71094 5.53141 5.53141C4.71094 6.35188 4.25 7.46468 4.25 8.625V14.25H14.25V4.25H8.625ZM4.25 18V28H14.25V18H4.25ZM18 18V28H28V18H18ZM31.75 18V28H41.75V18H31.75ZM28 31.75H18V41.75H28V31.75ZM31.75 41.75H37.375C38.5353 41.75 39.6481 41.2891 40.4686 40.4686C41.2891 39.6481 41.75 38.5353 41.75 37.375V31.75H31.75V41.75ZM31.75 14.25H41.75V8.625C41.75 7.46468 41.2891 6.35188 40.4686 5.53141C39.6481 4.71094 38.5353 4.25 37.375 4.25H31.75V14.25ZM28 4.25H18V14.25H28V4.25ZM4.25 31.75V37.375C4.25 39.79 6.21 41.75 8.625 41.75H14.25V31.75H4.25Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
